import { Link } from "react-router-dom";

import { Nav, Navbar, Container, Offcanvas, Dropdown, ListGroup, NavDropdown, } from 'react-bootstrap';
import logo from 'style/logo.jpg'
import insta from 'style/insta.jpg'
import kakaoplus from 'style/kakaoplus.png'

import { useSelector, useDispatch } from 'react-redux'
import { setId } from 'store/features/userInfo'

import db from 'service/db'

function Header() {
  const id = useSelector((state) => state.userInfo.id)
  const dispatch = useDispatch()

  function logout() {
    db.logout().then(i => {
      dispatch(setId(''))
    })
  }
  if (window.location.pathname.includes("/mbko")) return (<></>)
  else
    return (
      <>
        {/** 기본 메뉴 */}
        <div className="d-none d-xl-block">
          <Navbar expand="xl">
            <Container>
              <Navbar.Brand href="/"><img src={logo} height="72" alt="logo" /></Navbar.Brand>
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="justify-content-end align-items-center flex-grow-1 " style={{ fontWeight: 300, fontSize: 13 }}>
                  {id ?
                    <>
                      <Nav.Link className="md-6 mx-2 text-center" style={{ textDecoration: 'none', fontWeight: 700, fontSize: 13 }} onClick={logout}>로그아웃</Nav.Link>
                      <Link to="/imageboard" style={{ textDecoration: 'none', fontWeight: 700, fontSize: 13 }}>
                        <Nav.Link className="md-6 mx-2 text-center" href="#action2">메인 이미지</Nav.Link>
                      </Link>
                    </>
                    :
                    <Link to="/login" style={{ textDecoration: 'none', fontWeight: 700, fontSize: 13 }}>
                      <Nav.Link className="md-6 mx-2 text-center" href="#action2">&nbsp;</Nav.Link>
                    </Link>
                  }
                  <Link to="/" style={{ textDecoration: 'none', fontWeight: 700, fontSize: 13 }}>
                    <Nav.Link className="md-6 mx-2 align-middle" href="/">홈</Nav.Link>
                  </Link>
                  {/* |
                <Link to="/empty" style={{ textDecoration: 'none', fontWeight: 700, fontSize: 13 }}>
                  <Nav.Link className="md-6 mx-2 text-center" href="#action2">로그인</Nav.Link>
                </Link>
                |
                <Link to="/empty" style={{ textDecoration: 'none', fontWeight: 700, fontSize: 13 }}>
                  <Nav.Link className="md-6 mx-2 text-center" href="#action3">회원가입</Nav.Link>
                </Link> */}
                  <Nav.Link className="md-6 p-1 text-center" href="http://pf.kakao.com/_GNxeQb" ><img height="42" src={kakaoplus} alt="kakao" /></Nav.Link>
                  <Nav.Link className="md-6 p-1 text-center" href="https://www.instagram.com/official_kbsf/" ><img height="42" src={insta} alt="insta" /></Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
          <Dropdown.Divider style={{ margin: 0 }} />
          <Navbar key="md" expand="md" className="py-0 ">
            <Container className="justify-content-end ">
              <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${"md"}`} />
              <Navbar.Offcanvas
                aria-labelledby={`offcanvasNavbarLabel-expand-md`}
                placement="end"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-expand-md`}>
                    Offcanvas
              </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body >
                  <Nav className="container justify-content-between  flex-grow-1 px-5 py-0">
                    <NavDropdown title="한국브레인스포츠연맹" id="basic-nav-dropdown" width="560" style={{ fontWeight: 700, fontSize: 16, fontFamily: "Pretendard" }}>
                      <Link to="/welcome" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">인사말</Dropdown.Item>
                      </Link>
                      <Link to="/history" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">연혁</Dropdown.Item>
                      </Link>
                      <Link to="/chart" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">조직도</Dropdown.Item>
                      </Link>
                      <Link to="/map" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">오시는길</Dropdown.Item>
                      </Link>
                    </NavDropdown>
                    <NavDropdown title="교육/연수" id="basic-nav-dropdown" width="560" style={{ fontWeight: 700, fontSize: 16, fontFamily: "Pretendard" }}>
                      <Link to="/coachinfo" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">코치과정안내</Dropdown.Item>
                      </Link>
                      <Link to="/coachnotice" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">코치과정공지</Dropdown.Item>
                      </Link>
                      <Link to="/refereeinfo" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">심판과정안내</Dropdown.Item>
                      </Link>
                      <Link to="/refereenotice" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">심판과정공지</Dropdown.Item>
                      </Link>
                    </NavDropdown>
                    <NavDropdown title="대회/선수" id="basic-nav-dropdown" width="560" style={{ fontWeight: 700, fontSize: 16, fontFamily: "Pretendard" }}>
                      <Link to="/matchschedule" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">대회일정 및 신청</Dropdown.Item>
                      </Link>
                      <Link to="/matchresult" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">대회결과</Dropdown.Item>
                      </Link>
                      {/* <Link to="/participate" style={{ textDecoration: 'none' }}>
                      <Dropdown.Item href="#action/3.1">온라인 참가신청</Dropdown.Item>
                    </Link> */}
                    </NavDropdown>
                    <NavDropdown title="알림마당" id="basic-nav-dropdown" width="560" style={{ fontWeight: 700, fontSize: 16, fontFamily: "Pretendard" }}>
                      <Link to="/notice" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">공지사항</Dropdown.Item>
                      </Link>
                      {/* <Link to="/qna" style={{ textDecoration: 'none' }}>
                      <Dropdown.Item href="#action/3.1">문의게시판</Dropdown.Item>
                    </Link> */}
                      <Link to="/donationhistory" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">연간 기부금 모금액 내역</Dropdown.Item>
                      </Link>
                      <Link to="/donationusing" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">기부금 활용 실적 내역</Dropdown.Item>
                      </Link>
                      <Link to="/article" style={{ textDecoration: 'none' }}>
                        <Dropdown.Item href="#action/3.1">보도자료</Dropdown.Item>
                      </Link>
                    </NavDropdown>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
          <Dropdown.Divider style={{ margin: 0 }} />
        </div>
        {/** 모바일 반응형 */}
        <div className="d-xl-none">
          <Navbar key="md" expand="xl">
            <Container className="justify-content-between align-items-center">
              <Navbar.Brand href="/"><img src={logo} height="72" alt="logo" /></Navbar.Brand>
              <span className="d-flex">
                <Nav.Link className="p-0 px-1 md-6 text-center" href="http://pf.kakao.com/_GNxeQb" ><img height="36" src={kakaoplus} alt="kakao" /></Nav.Link>
                <Nav.Link className="p-0 px-1 md-6 text-center" href="https://www.instagram.com/official_kbsf/" ><img height="36" src={insta} alt="insta" /></Nav.Link>
                <Navbar.Toggle className="px-2" href="#action" aria-controls={`offcanvasNavbar-expand-${"md"}`} height="36" />
              </span>
              <Navbar.Offcanvas
                aria-labelledby={`offcanvasNavbarLabel-expand-md`}
                placement="end"
              >
                <Offcanvas.Header className="p-0" closeButton style={{ background: "rgb(36,36,122)" }} closeVariant="white">
                  {id ?
                    <div className="d-flex justify-content-between text-white" style={{ background: "rgb(36,36,122)", width: "100%" }}>
                      <Nav.Link onClick={logout} className="md-6 text-white" style={{ width: "100%", textAlign: "center" }} href="#action2">로그아웃</Nav.Link>
                    </div>
                    :
                    <div className="d-flex justify-content-between text-white" style={{ background: "rgb(36,36,122)", width: "100%" }}>
                      <Nav.Link className="md-6 text-white" style={{ width: "100%", textAlign: "center" }} href="/login" >&nbsp;</Nav.Link>

                      {/* <Nav.Link className="md-6 text-white" style={{ width: "50%", textAlign: "center" }} href="/login">로그인</Nav.Link>
                    <Nav.Link className="md-6 text-white" style={{ width: "50%", textAlign: "center" }} href="/empty">회원가입</Nav.Link> */}
                    </div>
                  }
                </Offcanvas.Header>
                <Offcanvas.Body className="p-0">
                  <ListGroup boarder>
                    <ListGroup.Item style={{ fontWeight: 500, fontSize: 21, fontFamily: "Pretendard", color: '#25247b', marginTop: "10px" }} >한국브레인스포츠연맹</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/welcome">인사말</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/history">연혁</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/chart">조직도</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/map">오시는길</ListGroup.Item>
                    <ListGroup.Item style={{ fontWeight: 500, fontSize: 21, fontFamily: "Pretendard", color: '#25247b', marginTop: "10px" }}>교육/연수</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/coachinfo">코치과정안내</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/coachnotice">코치과정공지</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/refereeinfo">심판과정안내</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/refereenotice">심판과정공지</ListGroup.Item>
                    <ListGroup.Item style={{ fontWeight: 500, fontSize: 21, fontFamily: "Pretendard", color: '#25247b', marginTop: "10px" }}>대회/선수</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/matchschedule">대회일정 및 신청</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/matchresult">대회결과</ListGroup.Item>
                    {/* <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/participate">온라인 참가신청</ListGroup.Item> */}
                    <ListGroup.Item style={{ fontWeight: 500, fontSize: 21, fontFamily: "Pretendard", color: '#25247b', marginTop: "10px" }}>알림마당</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/notice">공지사항</ListGroup.Item>
                    {/* <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/qna">문의게시판</ListGroup.Item> */}
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/donationhistory">연간 기부금 모금액 내역</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/donationusing">기부금 활용 실적 내역</ListGroup.Item>
                    <ListGroup.Item action style={{ background: "rgb(232,232,232)" }} href="/article">보도자료</ListGroup.Item>
                  </ListGroup>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
          <Dropdown.Divider style={{ margin: 0 }} />
        </div>
      </>
    );
}

export default Header;
